import { InventoryLocationItem } from "./inventoryV2";
import { Product } from "./product";
import { User } from "./user";

export interface InspectionListParams {
  keyword?: string;
  status?: InspectionOrderStatus;
  startTime?: number;
  endTime?: number;
};

export enum InspectionOrderStatus {
  DRAFT,
  PENDING,
  RESOLVED,
  REJECTED
};

export enum ExistEnum {
  NOT,
  YES,
  PART,
};

export enum ComplinEnum {
  NOT,
  YES,
  PART,
};

export interface InspectionOrderItem {
  id: string;                // 明细ID，非空
  inspectionOrderId: string; // 巡检单ID，非空
  productId: string;         // 物料ID，非空
  lotItemLocationId: string; // InventoryLotItemLocation.id，可空
  locationCode: string;      // 库位编码快照，可空
  existenceState: ExistEnum | null;         // 是否存在(0/1/2)，可空(null=未检)
  complianceState: ComplinEnum | null;        // 保管条件符合度(0/1/2)，可空(null=未检/不适用)
  action: string;            // 处理措施，可空
  inspectedAt: number | null,  // 巡检时间，可空|nu
  inspectedBy: string;       // 巡检人ID，可空
  inspector: User | null,               // 巡检执行人 UserRespDto，可空(null=未检)
  docId: string;             // 巡检照片目录(Docs.id，多张照片挂同一目录)，可空
  remark: string;
  itemLocation: InventoryLocationItem;
  product: Product;
};

export interface InspectionOrder {
  id: string;
  createdAt: number;
  updatedAt: number;
  planAt: number;
  finishedAt: number;
  number: string;
  items: InspectionOrderItem[];
  status: InspectionOrderStatus;
  orgId: string | null;
  remark: string;
};

export interface InspectionOrderAdd {
  productIds: string[];
  planAt: number;
  remark: string;
};

export interface InspectConfigAdd {
  needInspection: 0 | 1;          // 是否需要巡检(0否/1是)，非空
  cycleDays: number | null;               // 巡检周期(天)，可空(null=不定期/按需)
  content: string;          // 巡检内容说明，可空
  remark: string;         // 备注，可空
};

export interface InspectConfig extends InspectConfigAdd {
  id: string;              // 配置ID，非空
  productId: string;         // 物料ID，非空
  createdAt: number;    // 创建时间，非空
  updatedAt: number;     // 更新时间，非空
};

export interface InspectionProgress {
  orderId: string;
  orderNumber: string;
  status: InspectionOrderStatus;
  total: number;
  inspected: number;
  uninspected: number;
};

export interface InspectItemBody {
  existenceState: ExistEnum;
  complianceState: ComplinEnum;
  action: string;
  docId: string;
};